import React, { useEffect, useState } from "react";
import "../../../../style/main.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ActionModal = ({ show, handleClose }) => {
  const [select, setSelect] = useState(false);

  const handleSelectClose = () => setSelect(false);
  const handleSelectShow = () => setSelect(true);

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header>
        <Modal.Body className="action-modal-body">
          <h4>What Action Do You Want Your Agent To Take?</h4>
          <div className="radios mt-5">
            <label>
              <div className="radio-btns">
                <input type="radio" name="select" />
                <div className="two">
                  <h6>Book appointment</h6>
                  <p>
                    If you want your agent to book an appointment, select this
                    option. You'll be able to connect a calendar with your voxr
                    account for your agent to book appointments to.
                  </p>
                </div>
              </div>
            </label>
            <label>
              <div className="radio-btns ">
                <input type="radio" name="select" />
                <div className="two">
                  <h6>Book appointment</h6>
                  <p>
                    If you want your agent to book an appointment, select this
                    option. You'll be able to connect a calendar with your voxr
                    account for your agent to book appointments to.
                  </p>
                </div>
              </div>
            </label>
            <label>
              <div className="radio-btns  ">
                <input type="radio" name="select" />
                <div className="two">
                  <h6>Book appointment</h6>
                  <p>
                    If you want your agent to book an appointment, select this
                    option. You'll be able to connect a calendar with your voxr
                    account for your agent to book appointments to.
                  </p>
                </div>
              </div>
            </label>
          </div>
          <Button
            variant="primary"
            onClick={() => {
              handleSelectShow();
              handleClose();
            }}
            className="mt-5"
          >
            Use Selected Action Type
          </Button>
        </Modal.Body>
      </Modal>
      {/* Modal opens on clicks of  "Use selected Action button" */}
      <Modal show={select} onHide={handleSelectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSelectClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSelectClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ActionModal;
